import Vue from 'vue';
import utilities from '@/mixins/util.mixin';
import labels from '@/mixins/label.mixin';
import contrast from '@/mixins/contrast.mixin';

Vue.mixin(utilities);
Vue.mixin(labels);
Vue.mixin(contrast);
